import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import SupportPage from './pages/SupportPage';
import DeviceDetailsPage from './pages/DeviceDetailsPage';
import ProvisionDevicePage from './pages/ProvisionDevicePage';
import TroubleshootingPage from './pages/TroubleshootingPage';
import SettingsPage from './pages/SettingsPage';
import OrgPage from './pages/OrgPage';
import UsersPage from './pages/UsersPage';
import OrgUsersPage from './pages/OrgUsersPage';
import DevicesPage from './pages/DevicesPage';
import OrgDevicesPage from './pages/OrgDevicesPage';
import LogsPage from './pages/LogsPage';
import ScoringPage from './pages/ScoringPage';
import FirmwarePage from './pages/FirmwarePage';
import PlantsPage from './pages/PlantsPage';
import PlantProfileEditorPage from './pages/PlantProfileEditorPage';
import ReportsPage from './pages/ReportsPage';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivateRoute from './components/PrivateRoute';

import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';
import Toast from './components/Toast';
import EnvironmentBanner from './components/EnvironmentBanner';
import { useCookieConsent } from './hooks/useCookieConsent';

function App() {
        // Initialize cookie consent
        useCookieConsent();

        return (
                <ErrorBoundary>
                        <ToastProvider>
                                <AuthProvider>
                                        <Router>
                                                <Routes>
                                                        <Route path="/login" element={<LoginPage />} />
                                                        <Route path="/register" element={<RegisterPage />} />
                                                        <Route path="/reset-password" element={<ResetPasswordPage />} />
                                                        <Route path="/verify-email" element={<VerifyEmailPage />} />
                                                        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                                                        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                                                        <Route path="/troubleshooting" element={<TroubleshootingPage />} />
                                                        <Route element={<PrivateRoute />}>
                                                                <Route path="/" element={<DashboardPage />} />
                                                                <Route path="/support" element={<SupportPage />} />
                                                                <Route path="/device/:deviceId" element={<DeviceDetailsPage />} />
                                                                <Route path="/settings" element={<SettingsPage />} />
                                                                <Route path="/reports" element={<ReportsPage />} />
                                                                <Route path="/users" element={<UsersPage />} />
                                                                <Route path="/devices" element={<DevicesPage />} />
                                                                <Route path="/provision" element={<ProvisionDevicePage />} />
                                                                <Route path="/logs" element={<LogsPage />} />
                                                                <Route path="/scoring" element={<ScoringPage />} />
                                                                <Route path="/firmwares" element={<FirmwarePage />} />
                                                                <Route path="/plants" element={<PlantsPage />} />
                                                                <Route path="/plants/:profileId" element={<PlantProfileEditorPage />} />
                                                                <Route path="/org" element={<OrgPage />} />
                                                                <Route path="/org/:customerId" element={<DashboardPage />} />
                                                                <Route path="/org/:customerId/users" element={<OrgUsersPage />} />
                                                                <Route path="/org/:customerId/devices" element={<OrgDevicesPage />} />
                                                                <Route path="/org/:customerId/reports" element={<ReportsPage />} />
                                                        </Route>
                                                </Routes>
                                        </Router>
                                        <EnvironmentBanner />
                                        <Toast />
                                </AuthProvider>
                        </ToastProvider>
                </ErrorBoundary>
        );
}

export default App;
